import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Clock, User, FileEdit, UserPlus, Trash2, Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const getActionIcon = (action) => {
  const icons = {
    user_update: UserPlus,
    user_delete: Trash2,
    bulk_role_update: Settings,
    bulk_template_apply: FileEdit,
  };
  return icons[action] || User;
};

const getActionColor = (action) => {
  const colors = {
    user_update: 'text-blue-600',
    user_delete: 'text-red-600',
    bulk_role_update: 'text-purple-600',
    bulk_template_apply: 'text-green-600',
  };
  return colors[action] || 'text-gray-600';
};

const formatTimeAgo = (timestamp) => {
  const now = new Date();
  const date = new Date(timestamp);
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  
  if (diffMins < 1) return 'Az önce';
  if (diffMins < 60) return `${diffMins} dakika önce`;
  if (diffHours < 24) return `${diffHours} saat önce`;
  return `${diffDays} gün önce`;
};

export default function ActivityTimeline({ activities = [], limit = 10 }) {
  const navigate = useNavigate();
  const recentActivities = activities.slice(0, limit);
  
  return (
    <Card className="h-full">
      <CardHeader>
        <CardTitle className="text-lg flex items-center justify-between">
          <span>Son Aktiviteler</span>
          <Button 
            variant="ghost" 
            size="sm"
            onClick={() => navigate('/audit-logs')}
            className="text-xs"
          >
            Tümünü Gör →
          </Button>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {recentActivities.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground">
            <Clock className="w-12 h-12 mx-auto mb-2 opacity-50" />
            <p className="text-sm">Henüz aktivite yok</p>
          </div>
        ) : (
          recentActivities.map((activity, i) => {
            const Icon = getActionIcon(activity.action);
            const color = getActionColor(activity.action);
            
            return (
              <div key={i} className="flex items-start gap-3 pb-3 border-b last:border-0">
                <div className={`p-2 rounded-lg bg-gray-50`}>
                  <Icon className={`w-4 h-4 ${color}`} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate">
                    {activity.performed_by_email || 'Sistem'}
                  </p>
                  <p className="text-xs text-muted-foreground truncate">
                    {activity.changes?.join(', ') || activity.action}
                  </p>
                  <p className="text-xs text-muted-foreground mt-1">
                    {formatTimeAgo(activity.timestamp)}
                  </p>
                </div>
              </div>
            );
          })
        )}
      </CardContent>
    </Card>
  );
}
